import React, { Component } from "react";
import { connect } from "react-redux";
import ProductInList from "./ProductInList";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";
import ArrowForwardIosIcon from "@material-ui/icons/ArrowForwardIos";
import ScrollContainer from "react-indiana-drag-scroll";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import { Image } from "@material-ui/icons";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";

class Category extends Component {
  state = {
    is_scrollAble: true,
  };
  componentDidMount() {
    if (this.container.current) {
      let CheckScrollAble =
        this.container.current.container.current.scrollWidth >
        this.container.current.container.current.clientWidth;
      if (CheckScrollAble !== this.state.is_scrollAble) {
        this.setState({
          is_scrollAble: CheckScrollAble,
        });
      }
    }
  }

  container = React.createRef();
  shouldComponentUpdate = (prevProps, prevState) => {
    if (
      this.state.is_scrollAble != prevState.is_scrollAble ||
      this.props.language != prevProps.language
    )
      return true;
    return false;
  };
  render() {
    let products = [];
    const { settings, language, min_order, category } = this.props;
    try {
      products = category.products
        .slice(0, 8)
        .map((product, index) => (
          <ProductInList
            product={product}
            is_last={index + 1 === category.products.length ? true : false}
            is_first={index === 0 ? true : false}
            key={"gird_category_item " + product.name + " " + product.id}
            category_id={category.id}
          />
        ));
    } catch (err) {
      products = [];
    }

    let view_more_box = (
      <p
        key={"view_more_box" + " " + category.slug}
        onClick={() => this.props.history.push(`/category/${category.slug}`)}
        className="mx-4 pointer"
        style={{
          maxWidth: 100,
          minWidth: 100,
          height: 100,
          border: "2px #ccc dotted",
          paddingTop: 38,
          marginTop: 30,
          color: this.props.themeColor,

          fontFamily: language == "english" ? "Quicksand" : "Cairo",
        }}
      >
        {language === "english" ? "View all" : "شاهد المزيد"}
      </p>
    );
    const currencyIcon = getCurrencyIcon(settings);
    let min_order_text = category.minimum_order_value ? (
      <span>
        {language == "english" ? (
          <span>
            {" ( Min.order: "}
            <span
              className={
                  ["SAR", "AED"].includes(settings?.currency_iso) ? `${currencyIcon} ml-2` : ""
              }
            >
              {category.minimum_order_value} {settings?.currency_english}
            </span>
            {" )"}
          </span>
        ) : (
          <span>
            {" ( الحد الأدنى: "}
            <span
              className={
                ["SAR", "AED"].includes(settings?.currency_iso) ? `${currencyIcon} ml-2` : ""
              }
            >
              {category.minimum_order_value} {settings?.currency_local}
            </span>
            {")"}
          </span>
        )}
      </span>
    ) : null;

    const hasCoverPhoto =
      category?.cover_photo_large || category?.cover_photo ? true : false;

    return products.length ? (
      <div>
        <div
          className={"category_menu "}
          style={this.props.style}
          onClick={() => {
            if (!this.props.filter) {
              this.props.onClick(category.id);
            }
          }}
          id={"navigate" + category.id}
        >
          {hasCoverPhoto && (
            <div style={{ width: "100%", height: "clamp(180px, 25vw, 270px)" }}>
              <img
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: 5,
                }}
                src={category.cover_photo_large || category.cover_photo}
              ></img>
            </div>
          )}
          <h5
            className={language == "arabic" && "text-right"}
            style={{
              fontFamily: language == "english" ? "Quicksand" : "Cairo",
              marginTop: hasCoverPhoto && 15,
              paddingInline: hasCoverPhoto && 2,
            }}
          >
            {language === "arabic" ? this.props.arName : this.props.enName}
            {min_order_text ? min_order_text : ""}
            {!this.props.filter && (
              <span
                className={`${
                  language === "english" ? "float-right" : "float-left"
                }`}
              >
                <MoreHorizIcon />
              </span>
            )}
          </h5>
        </div>
        <div
          className="card"
          style={{
            border: 0,
            height: settings.show_nutrition_facts ? 380 : 350,
            width: "100%",
            backgroundColor: "white",
          }}
        >
          <p
            onClick={() =>
              this.props.history.push(`/category/${category.slug}`)
            }
            className="pointer mx-4"
            style={{
              color: this.props.themeColor,
              marginTop: 15,
              textAlign: language === "english" ? "right" : "left",
            }}
          >
            {language === "english" ? "View all" : "شاهد المزيد"}
          </p>
          <div
            className={`d-flex  align-items-center w-100 ${
              language === "arabic" ? "flex-row-reverse" : ""
            }`}
            style={{ marginTop: "15px" }}
          >
            {this.state.is_scrollAble && (
              <ArrowBackIosIcon
                className="pointer mx-1   "
                style={{ marginBottom: "55px" }}
                onClick={() =>
                  (this.container.current.container.current.scrollLeft += -100)
                }
              />
            )}
            <ScrollContainer
              vertical={false}
              ref={this.container}
              style={{
                width: "100%",

                overflowY: "hidden",
              }}
              className={`d-flex  ${
                !this.state.is_scrollAble ? "justify-content-center" : ""
              } `}
            >
              {this.state.is_scrollAble
                ? products.concat(view_more_box)
                : products}
            </ScrollContainer>
            {this.state.is_scrollAble && (
              <ArrowForwardIosIcon
                style={{ marginBottom: "55px" }}
                className="mx-1 pointer"
                onClick={() =>
                  (this.container.current.container.current.scrollLeft += 100)
                }
              />
            )}
          </div>
        </div>
      </div>
    ) : null;
  }
}
const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    categories: state.store.store.categories,
    cart: state.cart,
    branch: state.branch,
    settings: state.store.store.settings,
    discounts: state.cart.discounts,
    applied_promos: state.cart.smart_promos,
    themeColor: state.store.store.settings.dark,
  };
};

export default connect(mapStateToProps)(Category);
